module.exports = __webpack_public_path__ + "img/video3.30401464.png";